// Lightweight client-error reporter → forwards runtime JS errors to the backend
// error monitor (/api/client-error). Fire-and-forget, throttled, never throws.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

let _sent = 0;
let _windowStart = Date.now();
const MAX_PER_MINUTE = 10;
const _recent = new Set(); // dedupe identical messages within a session

function _throttled() {
  const now = Date.now();
  if (now - _windowStart > 60000) {
    _windowStart = now;
    _sent = 0;
  }
  if (_sent >= MAX_PER_MINUTE) return true;
  _sent += 1;
  return false;
}

export function reportClientError({ message, error_type, stack, component } = {}) {
  try {
    if (!BACKEND_URL || !message) return;
    const msg = String(message);
    if (msg.includes('ResizeObserver loop') || msg === 'Script error.') return;
    const key = `${error_type}|${msg}`.slice(0, 200);
    if (_recent.has(key)) return;
    _recent.add(key);
    if (_throttled()) return;

    let user_email = null;
    try {
      const u = JSON.parse(localStorage.getItem('voxsmyth_user') || 'null');
      user_email = u && u.email ? u.email : null;
    } catch (_) { /* ignore */ }

    // Keep-alive so it still sends during navigation/unload
    fetch(`${BACKEND_URL}/api/client-error`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      keepalive: true,
      body: JSON.stringify({
        message: msg.slice(0, 2000),
        error_type: error_type || 'ClientError',
        stack: (stack || '').slice(0, 8000),
        url: window.location.pathname,
        component: component || null,
        user_email,
      }),
    }).catch(() => {});
  } catch (_) {
    /* monitoring must never break the app */
  }
}

// Install global listeners once.
export function installClientErrorReporting() {
  if (typeof window === 'undefined' || window.__voxErrReporting) return;
  window.__voxErrReporting = true;

  window.addEventListener('error', (event) => {
    reportClientError({
      message: event.message || (event.error && event.error.message) || 'Unknown error',
      error_type: (event.error && event.error.name) || 'Error',
      stack: event.error && event.error.stack,
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason || {};
    reportClientError({
      message: reason.message || String(reason) || 'Unhandled promise rejection',
      error_type: reason.name || 'UnhandledRejection',
      stack: reason.stack,
    });
  });
}
